import React, { useState } from 'react';

import axios from 'axios';
import { useLocation } from 'react-router-dom';

import providerTemplate from './../../assets/Files/ProviderData_Upload_Template.xlsx';
import history from './../../history';
import FileUpload from './FileUpload';
import './ProviderFileUpload.css';
import ThankyouModal from './ThankyouModal';

import { isValidEmail } from '../../utils/isEmailValid';
import { APPLICATION_HEADERS, API_URLS } from '../common/headers';
import { TextField } from '../common/TextField/TextField';
import Layout from '../Layout/ProviderLayout';

const ProviderFileUpload = (props) => {
  const [providerEmail, setProviderEmail] = React.useState();
  const [emailError, setEmailError] = useState('');
  let isProviderUser = false;

  let dealID = '';
  const loc = useLocation();

  if (loc.pathname == '/uploadFile' && loc.search === '' && !sessionStorage.getItem('USER_DATA')) {
    sessionStorage.setItem('ISLOGGEDIN', false);
    sessionStorage.removeItem('result');
    sessionStorage.removeItem('prevPath');
    history.push('/MKII/');
    window.location.reload();
  }
  const query = new URLSearchParams(useLocation().search);

  if (query) {
    dealID = query.get('id');
    const uid = query.get('uniqueid');
    const uploadNeeded = query.get('uploadNeeded');

    if (uploadNeeded === 'NA') {
      return <ThankyouModal id={dealID} />;
    }
    // axios call to verify dealID and uniqueID

    const headers = APPLICATION_HEADERS.mkiiAPIKey;

    if (dealID) {
      const url = `${API_URLS.getDealURL.trimEnd()}?dealId=` + dealID;

      axios
        .get(url, { headers })
        .then((res) => {
          const logout = () => {
            sessionStorage.setItem('ISLOGGEDIN', false);
            sessionStorage.removeItem('result');
            sessionStorage.removeItem('prevPath');
            history.push('/MKII/');
            window.location.reload();
          };

          if (res && res.data && res.data.records.length > 0) {
            const unique_id = res.data.records[0].fields['Unique id'];

            if (unique_id === parseInt(uid)) {
              isProviderUser = true;
              sessionStorage.setItem('result', JSON.stringify(res));
              sessionStorage.setItem('TEAM_TYPE', 'Provider');
              sessionStorage.setItem('ISLOGGEDIN', true);
            } else {
              logout();
            }
          } else {
            logout();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  const onEmailChange = (event) => {
    setEmailError();
    const email = event.target.value;

    if (!isValidEmail(email)) {
      setEmailError('Please enter a valid email address');
      setProviderEmail('');
    }

    email && setProviderEmail(email);
  };

  return (
    <div>
      <Layout>
        <div className="fileContainer">
          <div className="uploadPage">
            <h4 className="titletext">Upload Locations</h4>
            <div className="field emailfield">
              <TextField
                id="outlined-basic"
                label="Your email address (required)"
                variant="outlined"
                onBlur={onEmailChange}
                fullWidth
                helperText={
                  emailError ||
                  'We will use this email only to communicate status of the file upload'
                }
                error={!!emailError}
              />
            </div>

            <div className="fileUploadContainer">
              <FileUpload providerEmail={providerEmail} dealID={dealID} />
            </div>
          </div>

          <div className="verticalLine">
            <h4 className="head2">Instructions</h4>
            <div>
              Step 1: Download the
              <a href={providerTemplate} download="ProviderUploadFileTemplate.xlsx">
                {' '}
                template
              </a>
            </div>
            <div>
              Step 2: Fill the data in the template and save.
              <i>
                {' '}
                All fields provided as part of the upload will be pre-populated as part of each
                survey request
              </i>
              <ul>
                <li>
                  Ensure that below mandatory fields are not blank
                  <ul>
                    <li>Provider Name</li>
                    <li>Address</li>
                    <li>City</li>
                    <li>Country</li>
                    <li> Provider Contact Email</li>
                  </ul>
                </li>
                <li>
                  There is a column for each Amenity. Please mark "Yes" if the amenity is available
                  at the location
                </li>
                <li>Please add "Available date" only in YYYY-MM-DD format</li>
                <li>File should contain 1000 or fewer rows</li>
              </ul>
            </div>
            <div> Step 3: Enter email address on the screen</div>
            <div>
              Step 4: Upload the file
              <ul>
                <li>You will receive an email once the process is completed.</li>
              </ul>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default ProviderFileUpload;
